/** Canonical field groups (SSOT). Add a new group here when introducing one. */
export const FIELD_GROUPS = ['textil', 'variations'];
/** Portuguese labels for UI display. */
export const FIELD_GROUP_LABELS = {
    textil: 'Têxtil',
    variations: 'Variações',
};
const FIELD_GROUP_SET = new Set(FIELD_GROUPS);
/**
 * Returns field-group names used by a descriptor that are not registered in {@link FIELD_GROUPS}.
 */
export function findUnknownFieldGroups(descriptor) {
    const unknown = new Set();
    for (const field of descriptor.fields) {
        for (const group of field.groups ?? []) {
            if (!FIELD_GROUP_SET.has(group)) {
                unknown.add(group);
            }
        }
    }
    for (const group of descriptor.repositoryConfig?.groups ?? []) {
        if (!FIELD_GROUP_SET.has(group)) {
            unknown.add(group);
        }
    }
    return [...unknown];
}
//# sourceMappingURL=fieldGroups.js.map